export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "start": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start"])},
      "apply": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apply for participate"])}
    }
  })
}
